/**
 * @generated SignedSource<<9843cf775729caa6c37a36fa564b6ab8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getLanguageAnnotations_pdpMetaItems$data = {
  readonly languageAnnotations: ReadonlyArray<{
    readonly href: string | null;
    readonly hrefLang: string | null;
  } | null> | null;
  readonly " $fragmentType": "getLanguageAnnotations_pdpMetaItems";
};
export type getLanguageAnnotations_pdpMetaItems$key = {
  readonly " $data"?: getLanguageAnnotations_pdpMetaItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"getLanguageAnnotations_pdpMetaItems">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getLanguageAnnotations_pdpMetaItems"
};

(node as any).hash = "8fb06e65d26bec8ebbea2f0c4868a4bd";

export default node;
